import { lazy } from "react";
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";

const Home = lazy(() => import("../pages/home/page"));
const BlogPage = lazy(() => import("../pages/blog/page"));
const BlogDetailPage = lazy(() => import("../pages/blog/detail/page"));
const BlogCategoryPage = lazy(() => import("../pages/blog/category/page"));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/blog",
    element: <BlogPage />,
  },
  {
    path: "/blog/category/:categorySlug",
    element: <BlogCategoryPage />,
  },
  {
    path: "/blog/:slug",
    element: <BlogDetailPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
